import { type LabelProps as RACLabelProps, Label as RACLabel } from "react-aria-components";
import { tv } from "tailwind-variants";

export type LabelProps = RACLabelProps & {
  /** @default 'default' */
  variant?: "default";
};

const labelStyles = tv({
  base: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 w-fit cursor-default",
  variants: {
    variant: {
      default: "text-gray-500 dark:text-zinc-400"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});

export function Label({ variant, className, ...props }: LabelProps) {
  return <RACLabel {...props} className={labelStyles({ variant, className })} />;
}
